export const VIDEO_CARD_MOBILE_HEIGHT = '11rem';
export const CONTROL_BUTTONS_POSITION_FOR_MOBILE = '1.6rem';
export const CONTROL_BUTTONS_SIZE_FOR_MOBILE = '2.4rem';
export const CONTROL_BUTTONS_SIZE_FOR_DESKTOP = '4.8rem';
export const VIDEO_ASPECT_RATIO = 16 / 9;
export const COVER_WIDTH = `${VIDEO_ASPECT_RATIO * 100}%`;
